import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import SvgIcon from '@components/SvgIcon'

interface LeftArrowFaderProps {
  scrollToStart: () => void
}

interface RightArrowFaderProps {
  scrollToEnd: () => void
}

interface ArrowsProps {
  direction: 'left' | 'right'
}

const Fader = styled.div<ArrowsProps>`
  ${({
    theme: {
      colors: { fillWeak },
      utils: { opacity },
    },
    direction,
  }) => css`
    height: 100%;
    position: absolute;
    ${direction}: 0;
    bottom: 0;

    background: linear-gradient(
      to ${direction},
      ${opacity(fillWeak, '00')} 4.44%,
      ${fillWeak} 62.22%
    );
    width: 34px;
  `}
`
const IconWrapper = styled.button<ArrowsProps>`
  ${({ direction }) => css`
    height: 100%;
    position: absolute;
    ${direction}: 0;
    bottom: 0;
    background: transparent;
    display: grid;
    align-items: center;
    justify-items: center;
    border: 0;
    cursor: pointer;
    padding: 0;
    line-height: 0;
    z-index: 1;
  `}
`

const LeftArrowFader: FunctionComponent<LeftArrowFaderProps> = ({
  scrollToStart,
}) => {
  const theme = useTheme()

  return (
    <>
      <IconWrapper
        aria-label="Scroll left"
        onClick={scrollToStart}
        direction="left"
      >
        <SvgIcon
          size={24}
          iconName="chevron-left"
          color={theme.colors.iconDefault}
        />
      </IconWrapper>
      <Fader direction="left" />
    </>
  )
}

const RightArrowFader: FunctionComponent<RightArrowFaderProps> = ({
  scrollToEnd,
}) => {
  const theme = useTheme()

  return (
    <>
      <IconWrapper
        aria-label="Scroll right"
        onClick={scrollToEnd}
        direction="right"
      >
        <SvgIcon
          size={24}
          iconName="chevron-right"
          color={theme.colors.iconDefault}
        />
      </IconWrapper>
      <Fader direction="right" />
    </>
  )
}

const ArrowFader = { Left: LeftArrowFader, Right: RightArrowFader }

export default ArrowFader
